import {
  AddressType,
  AllergySeverityCode,
  ContactMethod,
  ContactStatus,
  Gender,
  ImportantContactType,
  LPATypes,
  PhoneType
} from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const serviceUserProfileTranslations = {
  [Gender.male]: 'Male',
  [Gender.female]: 'Female',
  [Gender.any]: 'Any gender',
  [Gender.unknown]: 'Not known',
  [Gender.unspecified]: 'Not specified',
  [Gender.other]: 'Other',
  GENERAL_INFORMATION: 'General Information',
  LEGAL: 'Legal details',
  PROFILE_PICTURE: 'Profile Picture',
  NEEDS: 'Needs',
  UPLOAD: 'Upload',
  IMPORTANT_PEOPLE: 'Important people',
  ABOUT_ME: 'About me',
  PERSONAL_INFORMATION: 'Personal information',
  PERSONAL_NOTES: 'Personal notes',
  PERSONAL_NOTES_TOOLTIP:
    'In order to change this field, edit Personal Notes under Personal Information',
  DEMOGRAPHIC: 'Demographic',
  SITE_RELATED_INFORMATION: 'Site related information',
  CARE_RELATED_INFORMATION: 'Care related information',
  ACTIVE: 'Active',
  HOSPITAL_PASSPORT: 'Hospital Passport',
  GENDER_IDENTITY_INFO_TOOLTIP:
    'The gender identity of a person as stated by the person. This is where pronouns are taken from.',
  SEX_PHENOTYPIC_INFO_TOOLTIP:
    "The person's sex assigned at birth. Determines how the person will be treated clinically. Sex is pulled through into the Hospital passport.",
  HOSPITAL_PASSPORT_CONFIRM_SEX_TITLE: 'Confirm sex',
  HOSPITAL_PASSPORT_CONFIRM_SEX_BODY:
    'Please confirm the sex of this person is {{sex}}. If you confirm, we will save this and download the Hospital Passport.',
  HOSPITAL_PASSPORT_CONFIRM_SEX_OK: 'Yes - download now',
  HOSPITAL_PASSPORT_CONFIRM_SEX_CANCEL_NO: "That's not right",
  HOSPITAL_PASSPORT_SEX_MISSING_TITLE: 'Sex not recorded',
  HOSPITAL_PASSPORT_SEX_MISSING_BODY:
    'Sex is not recorded for this person. Add it under Personal information before downloading the Hospital Passport.',
  HOSPITAL_PASSPORT_SEX_MISSING_OK_UPDATE: 'Update now',
  HOSPITAL_PASSPORT_SEX_MISSING_CANCEL_DOWNLOAD_ANYWAY: 'Download anyway',
  CHANGED: 'Changed',
  ZONE: 'Zone',
  ZONE_TOOLTIP:
    'In order to change this field, edit Zone under Site Related Information',
  PRO_FEATURE: 'Pro! feature',
  CARE_TEAM_TOOLTIP:
    'In order to change this field, edit Care Team under Site Related Information',
  CARERS: 'Carers',
  ALL_CARERS: 'All carers',
  BUILDING_TOOLTIP:
    'In order to change this field, edit Building under Site Related Information',
  FLOOR_TOOLTIP:
    'In order to change this field, edit Floor under Site Related Information',
  ROOM_TOOLTIP:
    'In order to change this field, edit Room under Site Related Information',
  BED_TOOLTIP:
    'In order to change this field, edit Bed under Site Related Information',
  BUILDING: 'Building',
  FLOOR: 'Floor',
  ROOM: 'Room',
  BED: 'Bed',
  NEEDS_TOOLTIP: 'In order to change this field, edit Needs',
  VIEW_NEEDS_DETAILS: 'View needs details',
  EDIT_STATUS: 'Edit status',
  DELETE_PROFILE: 'Delete profile',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  REVIEW: 'Review',
  LEAVE_PAGE: 'Leave page',
  DO_NOT_CPR: 'Do Not Attempt CPR',
  VIEW_DNACPR_FORM: ' View DNACPR form',
  DNACPR_FORM_LOCATION: 'DNACPR form location',
  DNACPR_FORM_LOCATION_PLACEHOLDER: 'The physical location of the form',
  DNACPR_FORM: 'DNACPR form',
  CPR_Q: 'Attempt CPR?',
  CPR: 'Attempt CPR',
  NO_INFORMATION: 'No information entered',
  NO_DATE_SET: 'No date set',
  INDEFINITE_DECISION: 'Indefinite decision',
  LPS: 'LPS',
  DOLS: 'DoLS',
  DOLS_ENDING_TOOLTIP: 'Ending: {{date}}',
  RENEW: 'Renew date',
  ALLERGIES: 'Allergies',
  CONTACT_DETAILS: 'Contact details',
  CIRCUMSTANCES: 'Circumstances',
  SOCIAL_CIRCUMSTANCES: 'Social circumstances',
  EDUCATIONAL_HISTORY: 'Educational history',
  OCCUPATIONAL_HISTORY: 'Occupational history',
  PLEASE_ENTER: 'Please enter',
  FIRST_NAME_MAX_LENGTH: 'Given name must be 35 characters or less',
  LAST_NAME_MAX_LENGTH: 'Family name must be 35 characters or less',
  PREFERRED_NAME_MAX_LENGTH: 'Preferred name must be 70 characters or less',
  EDIT: 'Edit',
  ADD: 'Add',
  EDIT_PERSONAL_INFORMATION: 'Edit Personal Information',
  WHAT_IS_CURRENT: 'What is the current status?',
  NAME: 'Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  PREFERRED_NAME: 'Preferred Name',
  SELECT_GENDER: 'Select Gender',
  GENDER: 'Gender',
  GENDER_IDENTITY: 'Gender Identity',
  SELECT_GENDER_IDENTITY: 'Select Gender Identity',
  SEX: 'Sex',
  SELECT_SEX: 'Select Sex',
  SELECT_SEXUAL_ORIENTATION: 'Select Sexual Orientation',
  MALE: 'Male',
  FEMALE: 'Female',
  DATE_OF_BIRTH: 'Date of Birth',
  AGE: 'Age:',
  MARITAL_STATUS: 'Marital status',
  SELECT_MARITAL_STATUS: 'Select Marital status',
  BIRTHPLACE: 'Birthplace',
  NATIONALITY: 'Nationality',
  SELECT_NATIONALITY: 'Select Nationality',
  LANGUAGES_SPOKEN: 'Languages spoken',
  SELECT_LANGUAGES_SPOKEN: 'Select Languages spoken',
  ETHNICITY: 'Ethnicity',
  SELECT_ETHNICITY: 'Select Ethnicity',
  RELIGION: 'Religion',
  SELECT_RELIGION: 'Select Religion',
  PREGNANCY_STATUS: 'Pregnancy Status',
  SELECT_PREGNANCY_STATUS: 'Select Pregnancy Status',
  SEXUAL_ORIENTATION: 'Sexual Orientation',
  PERSONAL_NOTES_DESC: 'To add more details you can use the About me section',
  LPA_FORM_LOCATION: 'LPA Form Location',
  LPA_FORM_LOCATION_PLACEHOLDER: 'The physical location of the form',
  LPA_DATE_APPOINTED: 'LPA Date Appointed',
  MHA: 'Mental Health Act Legal Status',
  MHA_HAS_STATUS: 'Do they have current MHA status?:',
  MHA_HAS_STATUS_YES: 'Yes',
  MHA_HAS_STATUS_NO: 'No',
  MHA_TYPE: 'Enter MHA type',
  MHA_TYPE_PLACEHOLDER: 'E.g. Section 2 – Assessment',
  // site related information
  LOCATION: 'Location',
  ZONE_EXTRA: 'To select a Zone first you need to add it in',
  ZONE_EXTRA_LINK: 'Zones settings.',
  VIEW_PRO_PLAN: 'View Pro Plan',
  ASSIGN_TO_ALL_CARE_TEAM: 'Assign to all Care Team',
  ASSIGNED_CARE_TEAM: 'Assigned care team',
  ASSIGN_TO_ALL_CARE_TEAM_SUBLABEL:
    'Any tasks assigned to this {{variable}} will be seen by all Care Team',
  ASSIGN_TO_SELECTED_CARE_TEAM_MEMBERS: 'Assign to selected Care Team Members',
  INACTIVE_CARER: 'Inactive carer',
  LIBERTY: 'Liberty Protection Safeguard (LPS)',
  DEPRIVATION_LIBERTY: 'Deprivation of Liberty Safeguards (DoLS)',
  DEPRIVATION: 'Deprivation of Liberty Safeguards:',
  CARER_PREFERENCE: 'Carer Preference',
  CARER_GENDER: 'Carer Gender',
  CARER_GENDER_SELECT: 'Select Carer Gender',
  CARER_PREFERENCE_NOTE: 'Note',
  DATE_OF_OBSERVATION: 'Date of observation',
  // environment
  ENVIRONMENT: 'Environment',
  HOUSEHOLD_COMPOSITION: 'Household Composition',
  HOUSEHOLD_COMPOSITION_PLACEHOLDER: 'Lives alone, lives with partner',
  HOUSEHOLD_ENVIRONMENT: 'Household Environment',
  HOUSEHOLD_ENVIRONMENT_PLACEHOLDER:
    "Factors in the household which impact the person's health and wellbeing, including smoking in the home, alcohol/substance use",
  ENVIRONMENT_DESCRIPTION: 'Environment Description',
  ENVIRONMENT_DESCRIPTION_PLACEHOLDER:
    "Narrative description of features in a person's environment that could influence health or care provision, e.g. location of a stopcock outside a property",
  // access information
  ACCESS_INFORMATION: 'Access Information',
  SPECIAL_ACCESS_REQUIREMENTS: 'Special Access Requirements',
  // care related info
  CARE_INFORMATION: 'Care Related Information',
  DNACPR_CURRENT_STATUS_LABEL: 'Current status',
  DNACPR_DECISION_MADE_DATE: 'Date CPR decision was made:',
  DNACPR_ERROR: 'Please enter a DNACPR value',
  DNACPR_REVIEW_DATE_ERROR: 'Please enter a Review Date',
  DNACPR_SCHEDULED_DECISION: 'Decision',
  DNACPR_SCHEDULED_START: 'Start date',
  DNACPR_SCHEDULED_TITLE: 'Upcoming DNACPR',
  DNACPR_START_DATE_WARNING: "DNACPR won't commence until the start date",
  DNACPR_START_DATE: 'DNACPR Start Date',
  DNACPR: 'DNACPR',
  DUMMY: 'DUMMY',
  CHOKING_RISK: 'CHOKING RISK',
  DNACPR_TOOLTIP:
    'In order to change this field, edit DNACPR under Care Related Information',
  ATTEMPT_CPR: 'Attempt CPR',
  DO_NOT_ATTEMPT_CPR: 'Do not attempt CPR',
  CAUSATIVE_AGENT: 'Causative agent',
  CAUSATIVE_AGENT_ERROR: 'Please enter Causative agent',
  SELECT_CAUSATIVE_AGENT: 'Select Causative agent',
  TYPE_OF_REACTION: 'Type of reaction',
  TYPE_OF_REACTION_ERROR: 'Please enter Type of reaction',
  SEVERITY_OF_REACTION: 'Severity of reaction',
  DESCRIPTION: 'Description',
  NA: 'N/A',
  [AllergySeverityCode.mild]: 'Mild',
  [AllergySeverityCode.moderate]: 'Moderate',
  [AllergySeverityCode.severe]: 'Severe',
  [AllergySeverityCode.fatal]: 'Fatal',
  [AllergySeverityCode.life_threatening]: 'Life threatening',
  INTOLERANCE: 'Intolerance',
  ALLERGY_TOOLTIP:
    'In order to change this field, edit Allergies under Care Related Information',
  ALLERGY_TYPE: 'Allergy',
  REVIEW_DATE: 'Review Date',
  UPLOAD_FORM: 'Click to Upload',
  DNACPR_REVIEW_DATE: 'DNACPR review date',
  DNACPR_MODAL_TITLE: 'Read the DNACPR form',
  DNACPR_MODAL_CONTENT:
    'I confirm that I have carefully read the DNACPR form and every clinical decision will be made according to the content of it.',
  LIBERTY_PROTECTION_SAFEGUARD: 'Liberty Protection Safeguard:',
  SAFE_GUARD: 'Do they have a safeguarding measure in place?',
  ADD_ALLERGY: 'Add Allergy',
  ALLERGY_INDEX: 'Allergy {{variable}}',
  MENTAL_CAPACITY_TO_CONSENT:
    'Does this {{variable}} have the mental capacity to consent?',
  MENTAL_CAPACITY_TOOLTIP:
    'Updating whether a {{variable}} has mental capacity to consent will inform users of their consent status during the signature flow when you ask for consent',
  MENTAL_CAPACITY_CONSENT_QUESTION:
    'Does {{variable}} have capacity to give consent?',
  MENTAL_CAPACITY_HAS_CAPACITY:
    'Has capacity, based on mental capacity assessment.',
  MENTAL_CAPACITY_NO_CAPACITY:
    'Does not have capacity, based on mental capacity assessment.',
  MENTAL_CAPACITY_IN_PROGRESS:
    'Capacity assessment in progress, status not yet available.',
  MENTAL_CAPACITY_ASSESSMENT_IN_PROGRESS:
    'Mental capacity assessment in progress',
  RISK_OF_CHOKING: 'Risk of choking',
  NO_RISK: 'No risk',
  THERE_IS_A_RISK: 'There is a risk',
  BLOOD_TYPE: 'Blood Type',
  SELECT_BLOOD_TYPE: 'Select Blood Type',
  MEDICAL_HISTORY: 'Medical History',
  ADMISSION_DATE: 'Admission Date',
  SELECT_ADMISSION_DATE: 'Select Admission Date',
  SELECT_REVIEW_DATE: 'Select Review Date',
  NATIONAL_INSURANCE_NUMBER: 'National Insurance Number:',
  NHS_NUMBER: 'NHS Number',
  HEALTH_CARE_NUMBER: 'Health Care Number',
  NATIONAL_INSURANCE_NUMBER_ERROR:
    'Please enter a valid National Insurance Number',
  NHS_NUMBER_ERROR: 'Please enter a valid NHS Number',
  NHS_NUMBER_STATUS_INFO: 'Status info',
  NHS_NUMBER_REQUIRED_FOR_ROLE: 'NHS Number cannot be removed',
  OTHER_IDENTIFIER: 'Other Identifier',
  ADD_IDENTIFIER: 'Add identifier',
  DELETE_IDENTIFIER: 'Delete identifier',
  IDENTIFIER: 'Identifier',
  TYPE: 'Type',
  FUNDING_SOURCE: 'Funding source',
  SELECT_FUNDING_SOURCE: 'Select Funding source',
  OTHER_FUNDING_SOURCE: 'Other funding source',
  OTHER_DETAILS: 'Other details',
  NOTE: 'Note',
  LANGUAGE_AND_COMMUNICATION: 'Language and Communication',
  PREFFERED_LANGUAGE: 'Preferred Language',
  SIGN_LANGUAGE: 'Can they use sign language?',
  YES: 'Yes',
  NO: 'No',
  TABLETS_IN: 'Tablets in hand/pot/mouth:',
  HEIGHT: 'Height',
  CM: 'cm',
  PREFERRED_DRINK: 'Preferred drink',
  PRN_MEDS: 'PRN Meds',
  LPS_TOOLTIP:
    'In order to change this field, edit LPS under Care Related Information',
  LPS_START_DATE: 'LPS Start Date',
  LPS_END_DATE: 'LPS End Date',
  LPS_END_DATE_VALIDATION: 'LPS End Date must be after LPS Start Date',
  LPS_END_DATE_WARNING:
    'Once End Date is reached, LPS Status will not be active',
  LPS_REVIEW_DATE: 'LPS Review Date',
  LPS_APPLICATION_DATE: 'LPS Application Date',
  DOLS_TOOLTIP:
    'In order to change this field, edit DoLS under Care Related Information',
  DOLS_START_DATE: 'DoLS Start Date',
  DOLS_END_DATE: 'DoLS End Date',
  DOLS_END_DATE_VALIDATION: 'DoLS End Date must be after DoLS Start Date',
  DOLS_END_DATE_WARNING:
    'Once End Date is reached, DoLS Status will not be active',
  DOLS_REVIEW_DATE: 'DoLS Review Date',
  DOLS_APPLICATION_DATE: 'DoLS Application Date',
  REVIEW_DATE_OVERDUE: 'Review date overdue',
  NO_KNOWN_ALLERGIES: 'No known allergies',

  // reasonable adjustments
  REASONABLE_ADJUSTMENT: 'Reasonable adjustment',
  REASONABLE_ADJUSTMENTS: 'Reasonable adjustments',
  ADD_REASONABLE_ADJUSTMENT: 'Add reasonable adjustment',
  DELETE_REASONABLE_ADJUSTMENT: 'Delete reasonable adjustment',
  REASONABLE_ADJUSTMENT_DETAILS: 'Details',
  REASONABLE_ADJUSTMENT_CATEGORY: 'Categories of adjustments',
  REASONABLE_ADJUSTMENT_IMPAIRMENT: 'Impairments',
  SELECT_ADJUSTMENT_CATEGORY: 'Select Category of adjustment',
  SELECT_IMPAIRMENT: 'Select Impairment',
  REASONABLE_ADJUSTMENT_SUBCATEGORY: 'Subcategories',
  SELECT_ADJUSTMENT_SUBCATEGORY: 'Select subcategory',
  NO_REASONABLE_ADJUSTMENTS: 'No reasonable adjustments',

  // contact details
  ADDRESS: 'Address',
  ADDRESS_CURRENT: 'Current Address',
  ADDRESS_PREVIOUS: 'Previous Address / Admitted from',
  ADD_ADDRESS: 'Add address',
  ADDRESS_TYPE: 'Address type',
  ACCOMMODATION_STATUS: 'Accommodation status',
  ADDRESS_LINE_1: 'Address line 1',
  ADDRESS_LINE_2: 'Address line 2',
  SELECT_ADDRESS_TYPE: 'Select Address type',
  PHONE_NO: 'Phone number',
  PHONE_NO_TYPE: 'Phone number type',
  SELECT_PHONE_NO_TYPE: 'Select Phone number type',
  ADD_PHONE_NO: 'Add phone number',
  BUILDING_NAME: 'Building name',
  EMAIL: 'Email address',
  PREFERRED_CONTACT_METHOD: 'Preferred contact method',
  NO_PREFERENCE: 'No preference',
  TOWN_CITY: 'Town / City',
  POSTCODE: 'Postcode',
  DELETE_ADDRESS: 'Delete Address',
  ADDRESS_NOT_VALID_FOR_GEOFENCING_TOOLTIP:
    'Unable to locate this address for geofencing',
  CHANGES_SAVED_INVALID_GEOFENCING_ADDRESSES:
    'Changes saved. Some addresses are invalid for geofencing, please check warnings below.',
  MULTIPLE_MAIN_PERMANENT_RESIDENCE_WARNING:
    'This {{residentNominative}} has more than one main permanent residence.',
  DELETE_PHONE_NO: 'Delete Phone number',
  DELETE_SCENARIO: 'Delete Scenario',
  MAIN_PERMANENT_RESIDENCE: 'Main Permanent Residence',
  [AddressType.Main_Permanent_Residence]: 'Main Permanent Residence',
  [AddressType['Correspondence_(Non-Residence)']]:
    'Correspondence (Non-Residence)',
  [AddressType.Invoice]: 'Invoice',
  [AddressType.Main_Business_Premises]: 'Main Business Premises',
  [AddressType.Other_Business_Premises]: 'Other Business Premises',
  [AddressType.Other_Permanent_Residence]: 'Other Permanent Residence',
  [AddressType.Safe_Haven_ADDRESS]: 'Safe Haven Address',
  [AddressType.Temporary_Residence]: 'Temporary Residence',
  // ImportantPeople
  ADD_CONTACT: 'Add contact',
  [ImportantContactType.personal]: 'Personal',
  [ImportantContactType.professional]: 'Professional',
  DEPENDANT: 'Dependant',
  DEPENDANT_DATE_OF_BIRTH: 'Dependant date of birth',
  LINKED_CONTACT_DETAILS_TITLE: 'Main contact for this dependant',
  LINKED_CONTACT_DETAILS_SUBTITLE:
    'This is the person we should contact regarding this dependant. For example, a guardian or teacher.',
  DEPENDANT_LINKED_CONTACT_RELATIONSHIP: 'Relationship to the dependant',
  DEPENDANT_VIEW_LINKED_NAME: 'Linked contact name',
  DEPENDANT_VIEW_LINKED_RELATIONSHIP: 'Relationship to the dependant',
  DEPENDANT_VIEW_LINKED_TEL1: 'Linked contact telephone 1',
  DEPENDANT_VIEW_LINKED_TEL2: 'Linked contact telephone 2',
  DEPENDANT_VIEW_LINKED_EMAIL: 'Linked contact email',
  GP: 'GP',
  SURGERY_PRACTICE_NAME: `Surgery / Practice name`,
  PRACTICE_CODE: 'Prefix GP practice code Suffix',
  MOBILE_NUMBER: 'Mobile number',
  NEXT_OF_KIN: 'Next of Kin',
  LASTING_POWER_OF_ATTORNEY: 'Lasting Power of Attorney',
  OBSERVATION_ABOUT_THIS_PERSON: 'Observation about this person',
  COUNTRY: 'Country',
  TELEPHONE1: 'Telephone 1',
  TELEPHONE2: 'Telephone 2',
  CONTACT_STATUS: 'Contact status',
  priority: 'Priority',
  secondary: 'Secondary',
  doNotContact: 'Do not contact',
  CONTACTABLE_TIMES: 'Contactable times',
  FAMILY_PORTAL_STATUS: 'Family app status',
  ACCESS: 'Access',
  ACCESS_HELP_MESSAGE: `This decision should always be in {{residentName}}'s best interests if they cannot make it themselves. If no is selected, you will not be able to send an invite.`,
  JUSTIFICATION_OF_DECISION: 'Justification of decision',
  ACTIVE_SINCE_DATE: 'Active since {{date}}',
  ACTIVE_SINCE: 'Active since',
  ANY_CHANGES_WILL_AUTOMATICALLY_CREATE_A_LOG:
    'Any changes will automatically create a log.',
  ROLE: 'Role',
  ORGANISATION: 'Organisation',
  SPECIALITY: 'Speciality',
  OBSERVATION_NOTES: 'Observation notes',
  RELATIONSHIP: 'Relationship',
  TYPE_IN_ADDRESS_MANUALLY: 'Type in address manually',
  [LPATypes.HEALTH_AND_WELLBEING]: 'Health and wellbeing',
  [LPATypes.FINANCIAL]: 'Financial',
  [`LPA_${LPATypes.HEALTH_AND_WELLBEING}`]: 'LPA Health & Wellbeing',
  [`LPA_${LPATypes.FINANCIAL}`]: 'LPA Financial',
  FAMILY_PORTAL: 'Family app',
  EDITED_BY: 'Edited by',
  EDIT_DATE: 'Edit date',
  WHY_THIS_DECISION_HAS_BEEN_MADE: 'Why this decision has been made',
  INVITATION_TEXT: `Before creating the invitation, please ensure that the correct permissions have been obtained for this person to have access to {{name}}'s information.`,
  NO_EMAIL_TEXT: `To be able to send and invite for Family app please enter an email address for contact.`,
  RESEND_INVITE: 'Resend invite',
  CREATE_INVITE: 'Create invite',
  DOCTOR_NAME: 'Doctor name',
  GP_PRACTICE_CODE: 'GP practice code',
  READY_SET_GO_THE_JOURNEY_STARTS_HERE:
    'Ready, set, go! The journey starts here',
  PRESS_THAT_BLUE_BUTTON_AT_THE_TOP_RIGHT_OF_THE_PAGE:
    'Press that blue button at the top right of the page.',
  CHOOSE_GP_FROM_LIST: 'Choose GP from list',
  TYPE_MANUALLY: 'Type Manually',
  [`${PhoneType.mobile}_NUMBER`]: 'Mobile number',
  [`${PhoneType.home}_NUMBER`]: 'Home number',
  [`${PhoneType.old}_NUMBER`]: 'Old number',
  [`${PhoneType.temp}_NUMBER`]: 'Temporary number',
  [`${PhoneType.work}_NUMBER`]: 'Work number',
  [ContactMethod.email]: 'Email',
  [ContactMethod.phone]: 'Phone',
  [ContactMethod.fax]: 'Fax',
  [ContactMethod.sms]: 'SMS',
  [ContactMethod.url]: 'URL',
  [ContactMethod.noPreference]: 'No preference',
  GP_CODE_VALIDATION_ERROR: 'GP code is invalid',
  [ContactStatus.priority]: 'Priority',
  [ContactStatus.secondary]: 'Secondary',
  [ContactStatus.doNotContact]: 'Do not contact',
  //
  DELETE_ALLERGY: 'Delete Allergy',
  SELECT_DATE: 'Select date',

  NO_RESIDENT: 'Shoot... no resident to show you',
  MEDICATIONS: 'Medications',

  EARLY_ACCESS_TITLE: 'Early Access',
  EARLY_ACCESS_DESCRIPTION:
    'Discover our new {{variable}} Profile and share your feedback',
  EARLY_ACCESS_BUTTON: 'Share your feedback',
  PERSONAL_CONTACT: 'Personal contact',
  GP_DETAILS: 'GP details',
  PROFESSIONAL_CONTACT: 'Professional contact',
  FULL_NAME: 'FULL_NAME',
  RELATIONSHIP_ROLE: 'Relationship / Role',
  RESIDENT_UPDATED: '{{variable}} updated',
  RESIDENT_DELETED: '{{variable}} deleted',
  MODAL_TITLE: 'Are you sure you want to leave this page?',

  // contingency plans
  CONTINGENCY_PLANS: 'Contingency Plans',
  CONTINGENCY_PLAN: 'Contingency Plan',
  NO_PLANS: 'Shoot... No Contingency Plans to show you',
  NO_PLANS_DESCRIPTION:
    'Start adding Contingency Plans with the blue button on the top right.',
  NO_PLAN: 'Shoot... No Contingency Plan to show you',
  ADD_NEW_PLAN: 'Add new Plan',
  PLAN_NAME: 'Plan name',
  SCENARIO: 'Scenario',
  SCENARIOS: 'Scenarios',
  ADD_SCENARIO: 'Add Scenario',
  ADVANCED_STATEMENTS: 'Advanced Statements',
  ADVANCED_STATEMENT: 'Advanced Statement',
  ADD_ADVANCED_STATEMENT: 'Add Advanced Statement',
  DELETE_ADVANCED_STATEMENT: 'Delete Advanced Statement',
  TITLE: 'Title',
  TRIGGER_FACTOR: 'Trigger factor',
  WHAT_SHOULD_HAPPEN: 'What should happen',
  WHO_SHOULD_BE_CONTACTED: 'Who should be contacted',
  ANTICIPATORY_MEDS: 'Anticipatory medications / Equipment',
  AGREED_WITH_PERSON: 'Agreed with person',
  LEGITIMATE_REPRESENTATIVE: 'Legitimate Representative',
  NEXT_REVIEW: 'Next review',
  DATE_UPDATED: 'Last updated',
  ONE_MONTH: '1 months',
  THREE_MONTHS: '3 months',
  SIX_MONTHS: '6 months',
  TWELVE_MONTHS: '12 months',
  CUSTOM: 'Custom',
  CONTINGENCY_PLAN_CREATED: 'Contingency Plan created',
  CONTINGENCY_PLAN_UPDATED: 'Contingency Plan updated',
  CONTINGENCY_PLAN_DELETED: 'Contingency Plan deleted',
  DELETE_PLAN_CONFIRMATION: 'Are you sure you want to delete this Plan?',
  DELETE_PLAN_INFO: 'You can’t undo changes after selecting delete.',
  OVERDUE: 'OVERDUE',
  CONFIRM: 'Confirm',
  CARE_TEAM: 'Care Team',
  KEYWORKERS: 'Keyworkers',
  NOT_ASSIGNED: 'Not assigned',
  KEYWORKERS_TOOLTIP:
    'In order to change this field, edit Keyworkers under Site Related Information',
  KEYWORKERS_TOOLTIP_SELECT:
    'Team members added to this field will be able to perform reviews directly in the app',
  KEYWORKERS_TOOLTIP_HELP:
    'Selected keyworkers has to be selected firstly in Care Team',
  FUTURE_PLANS: 'Future Plans',
  FUTURE_PLAN: 'Future Plan',
  FUTURE_PLAN_CREATED: 'Future Plan created',
  FUTURE_PLAN_UPDATED: 'Future Plan updated',
  FUTURE_PLAN_DELETED: 'Future Plan deleted',
  UNPAID_CARER: 'Unpaid Carer',
  PROXY_FOR_SUBJECT_OF_CARE: 'Proxy for Subject of Care',
  LOCATION_OF_DOCUMENT: 'Location of document',
  PROXY: 'Proxy',

  // Death details
  DEATH_DETAILS_TITLE: 'Details of death',
  DEATH_DETAILS_WELLWISH_MESSAGE: 'We hope you and the team are okay.',
  DATE_OF_DEATH: 'Date of death',
  DETAILS_OF_DEATH: 'Details of death',
  DEATH_DETAILS_EDIT_HINT:
    'To update death details, change the status from the profile page.',
  NEXT: 'Next',
  BACK: 'Back'
}

export const serviceUserProfileConstants = getKeys(
  serviceUserProfileTranslations
)
